<script setup lang="ts">
const openedList = inject<Ref<boolean>>('openedList') || ref(false)

const { isTablet_sm } = useWindowWidth()
const { locale } = useI18n()

const props = defineProps<{
	scroll: boolean
	contact?: boolean
}>()

const bookerStore = useBookerStore()
const localePath = useLocalePath()
const router = useRouter()
const route = useRoute()
const reservationStore = useReservationStore()
const items = ref<ILocationModel[] | undefined>(undefined)
const locationsStore = useLocationsStore()
const mapStore = useMapStore()

const filter = ref('')

// const getLocations = async () => {
// 	if (locationsStore.getFetchingLocations) return
// 	locationsStore.setFetchingLocations(true)
// 	try {
// 		const locations = reservationStore.getAllLocations
// 		if (locations && locations.length > 0) {
// 			items.value = locations
// 			return
// 		}
// 		const { data } = await ApiService.fetchAllLocations(1, 100, undefined, true)
// 		items.value = data

// 		// for (const item of items.value) {
// 		// 	// check if item has crm_id if not delete
// 		// 	if (!item?.crmID) {
// 		// 		const index = items.value?.indexOf(item)
// 		// 		items.value?.splice(index, 1)
// 		// 	}
// 		// }

// 		reservationStore.updateAllLocations(data)
// 	} catch (error) {
// 		console.log(error)
// 	}
// 	locationsStore.setFetchingLocations(false)
// }
onMounted(async () => {
	// getLocations()
	items.value = await locationsStore.fetchLocations()
})

watch(
	() => reservationStore.getAllLocations,
	(newValue) => {
		if (newValue) {
			items.value = newValue

			// for (const item of items.value) {
			// 	// check if item has crm_id if not delete
			// 	if (!item?.crmID) {
			// 		const index = items.value?.indexOf(item)
			// 		items.value?.splice(index, 1)
			// 	}
			// }
		}
	},
	{
		immediate: true,
		deep: true,
	},
)

const filteredDepartments = computed(() => {
	if (!filter.value || filter.value?.trim()?.length === 0) {
		return items.value?.filter((i) => !props.contact || i.purpose !== 'meet_and_greet').sort((a, b) => a.order - b.order)
	}

	return items.value
		?.filter((item) => {
			const searchableFields = [
				item.city?.toLowerCase(),
				item.address_street?.toLowerCase(),
				item.name?.toLowerCase(),
				item.nameEn?.toLowerCase(),
			]

			return searchableFields.some((field) => field?.includes(filter.value?.toLowerCase()))
		})
		.filter((i) => !props.contact || (i.purpose !== 'meet_and_greet' && i.icon !== 'airplane'))
		.sort(
			(a, b) =>
				Number(b.city?.toLowerCase().startsWith(filter.value?.toLowerCase())) -
				Number(a.city?.toLowerCase().startsWith(filter.value?.toLowerCase())),
		)
})

const sendAnalyticsData = (item: any) => {
	const gtmService = useGTMService()
	if (!gtmService) return
	const GTMParameters = {
		section: 'locations',
		element: 'location',
		element_value: 'cars',
		location: item.city
			?.toLowerCase()
			?.normalize('NFD')
			?.replace(/[\u0300-\u036F]/g, ''),
	}
	gtmService.offerInterest(GTMParameters)
}

const handleElementClick = (item: any) => {
	mapStore.setOpenTooltip(false)
	if (props.contact) {
		contactElementClick(item)
	} else {
		normalElementClick(item)
	}
}

const normalElementClick = (item: any) => {
	if (openedList && openedList.value && isTablet_sm) openedList.value = false
	bookerStore.setSelectedLocations(item, undefined)
	reservationStore.setBookerLocations({ ...item, end: null })
	reservationStore.addLocationToHistory(item.id)
	sendAnalyticsData(item)
	mapStore.setClickedLocation(item)
	if (route.name?.toString().slice(0, -5) === 'locations') router.push(localePath('cars'))
}

const contactElementClick = (item: any) => {
	mapStore.setClickedLocation(item)
	mapStore.setOpenTooltip(true)
}

watch(
	() => openedList.value,
	(value) => {
		if (value) {
			// focus on input
			const input = document.querySelector('.search-list__input') as HTMLInputElement
			setTimeout(() => {
				if (input) input.focus()
			}, 10)
		}
	},
)

const itemNameLabel = (item: ILocationModel) => {
	return locale.value === 'pl' ? item.name : item.nameEn
}
</script>

<template>
	<div class="search-list" :data-scroll="props.scroll" :class="{ 'search-list--opened': openedList && isTablet_sm }">
		<div class="search-list__search-container">
			<div style="position: relative">
				<input v-model="filter" class="search-list__input" type="text" :placeholder="$t('components.departments.search_list.placeholder')" />
				<ButtonPrimary class="search-list__btn" size="small">
					<GlobalIcon name="search-normal" :width="20" />
				</ButtonPrimary>
			</div>
		</div>
		<div class="search-list__list-container">
			<span class="search-list__label">{{
				contact ? $t('components.departments.search_list.contact_label') : $t('components.departments.search_list.label')
			}}</span>
			<Transition name="fade" mode="out-in">
				<div v-if="filteredDepartments && filteredDepartments?.length > 0" class="search-list__list">
					<div v-for="(item, idx) in filteredDepartments" :key="idx" class="search-list__item" @click="handleElementClick(item)">
						<GlobalIcon v-if="item.purpose === 'meet_and_greet'" class="search-list__item-icon" name="location-bold" :width="20" />
						<GlobalIcon v-else-if="item.icon === 'airplane'" class="search-list__item-icon" name="airplane" :width="20" />
						<GlobalIcon v-else-if="item.icon" class="search-list__item-icon" name="location-filled" :width="20" />
						<p class="search-list__item-text">{{ itemNameLabel(item) }}</p>
					</div>
				</div>
				<div v-else class="search-list__loader">
					<v-progress-circular indeterminate color="var(--primary-color)"></v-progress-circular>
				</div>
			</Transition>
		</div>
	</div>
</template>

<style scoped lang="scss">
@import './SearchList.scss';
</style>
